// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_6c97079b1b--wrapper--D_exz","banner":"_6c97079b1b--banner--C3YY6","list":"_6c97079b1b--list--Vb33n","pagination":"_6c97079b1b--pagination--jE0Qg"};